import { PersistentFormControl, PersistentFormGroup } from '@utility/persistent-forms';

export class SiteServicesPaymentValidationFormGroup extends PersistentFormGroup<{
    kycDocumentationControl: PersistentFormControl<boolean | null>;
    readyForPaymentControl: PersistentFormControl<boolean | null>;
}> {
    constructor() {
        super({
            kycDocumentationControl: new PersistentFormControl<boolean | null>(null),
            readyForPaymentControl: new PersistentFormControl<boolean | null>(null),
        });
    }
}
